import { JsonConvert, ValueCheckingMode } from "json2typescript";
export class hSerializer extends JsonConvert {
    constructor() {
        super();
        this.valueCheckingMode = ValueCheckingMode.ALLOW_NULL;
        // this.ignorePrimitiveChecks = false
    }
}
//# sourceMappingURL=h-serializer.js.map